"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _Breadcrumbs = _interopRequireDefault(require("@material-ui/core/Breadcrumbs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreadcrumbsStyled = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      '& .MuiBreadcrumbs-separator': {
        height: '1.25rem;',
        // color: theme.palette.secondary.main,
        fontSize: '1.25rem;',
        fontWeight: '500;'
      },
      '& .MuiBreadcrumbs-li': {
        paddingBottom: '0.3125rem;'
      },
      '& .MuiTypography-root': {
        '&.breadcrumbItem-icon': {
          '& .MuiSvgIcon-root': {
            marginRight: '0.125rem;'
          }
        },
        '&.MuiLink-root': {
          display: 'flex',
          textAlign: 'left;'
        }
      }
    }
  };
})(_Breadcrumbs.default);
var _default = BreadcrumbsStyled;
exports.default = _default;